import i18n from '../i18n';
import api from '../api/publicSurveyApi';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';
import routePaths from '../routePaths';
import history from '../history';

export const types = {
  GET_THREADS: 'GET_THREADS',
  GET_THREADS_SUCCESS: 'GET_THREADS_SUCCESS',
  GET_THREADS_FAILURE: 'GET_THREADS_FAILURE',
  CREATE_THREAD_SUCCESS: 'CREATE_THREAD_SUCCESS',
  CREATE_THREAD_FAILURE: 'CREATE_THREAD_FAILURE',
  ADD_POST_SUCCESS: 'ADD_POST_SUCCESS',
  ADD_POST_FAILURE: 'ADD_POST_FAILURE',
  GET_POSTS: 'GET_POSTS',
  GET_POSTS_SUCCESS: 'GET_POSTS_SUCCESS',
  GET_POSTS_FAILURE: 'GET_POSTS_FAILURE',
  GET_NEXT_POSTS: 'GET_NEXT_POSTS',
  GET_NEXT_POSTS_SUCCESS: 'GET_NEXT_POSTS_SUCCESS',
  GET_NEXT_POSTS_FAILURE: 'GET_NEXT_POSTS_FAILURE',
  ADD_POST_REACTION_SUCCESS: 'ADD_POST_REACTION_SUCCESS',
  ADD_POST_REACTION_FAILURE: 'ADD_POST_REACTION_FAILURE',
  UNDO_POST_REACTION_SUCCESS: 'UNDO_POST_REACTION_SUCCESS',
  UNDO_POST_REACTION_FAILURE: 'UNDO_POST_REACTION_FAILURE',
};

export const actions = {
  getThreads: surveyId => dispatch => {
    dispatch({ type: types.GET_THREADS });

    return api
      .getThreads(surveyId)
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.GET_THREADS_SUCCESS, data: response.data });
        }

        dispatch({ type: types.GET_THREADS_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.getThreadsFailure')));
        return logger.error(response);
      });
  },
  createThread: (surveyId, data, redirectToSurveyDetails) => dispatch => {
    return api
      .createThread(surveyId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.CREATE_THREAD_SUCCESS, id: response.data.id, title: data.title });
          if (redirectToSurveyDetails) {
            dispatch(notificationActions.showSuccess(i18n.t('surveys.actions.createThreadSuccess')));    
            return;
          } else {
            return history.push(routePaths.board.replace(':id', surveyId).replace(':threadId', response.data.id));
          }
        }

        dispatch({ type: types.CREATE_THREAD_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.createThreadFailure')));
        return logger.error(response);
      });
  },
  getPosts: (surveyId, threadId, limit, offset) => dispatch => {
    dispatch({ type: types.GET_POSTS });

    return api
      .getPosts(surveyId, threadId, limit, offset)
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.GET_POSTS_SUCCESS, data: response.data, limit, offset });
        }

        dispatch({ type: types.GET_POSTS_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.getPostsFailure')));
        return logger.error(response);
      });
  },
  getNextPosts: (surveyId, threadId, limit, offset) => dispatch => {
    dispatch({ type: types.GET_NEXT_POSTS });

    return api
      .getPosts(surveyId, threadId, limit, offset)
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.GET_NEXT_POSTS_SUCCESS, data: response.data, limit, offset });
        }

        dispatch({ type: types.GET_NEXT_POSTS_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.getPostsFailure')));
        return logger.error(response);
      });
  },
  addPost: (surveyId, threadId, data) => (dispatch, getState) => {
    const user = getState().account.data;

    return api
      .addPost(surveyId, threadId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.ADD_POST_SUCCESS, data: response.data, user });
          dispatch(notificationActions.showSuccess(i18n.t('surveys.actions.addPostSuccess')));
          return true;
        }

        dispatch({ type: types.ADD_POST_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.addPostFailure')));
        return logger.error(response);
      });
  },
  addReaction: (surveyId, threadId, postId, reaction) => dispatch => {
    return api
      .react(surveyId, threadId, postId, reaction)
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.ADD_POST_REACTION_SUCCESS, surveyId, threadId, postId, reaction });
        }

        dispatch({ type: types.ADD_POST_REACTION_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.addPostReactionFailure')));
        return logger.error(response);
      });
  },
  undoReaction: (surveyId, threadId, postId, reaction) => dispatch => {
    return api
      .undoReact(surveyId, threadId, postId, reaction)
      .then(response => {
        if (response.ok) {
          return dispatch({ type: types.UNDO_POST_REACTION_SUCCESS, surveyId, threadId, postId, reaction });
        }

        dispatch({ type: types.UNDO_POST_REACTION_FAILURE });
        dispatch(notificationActions.showError(i18n.t('surveys.actions.undoPostReactionFailure')));
        return logger.error(response);
      });
  },
};



// WEBPACK FOOTER //
// ./src/actions/boardActions.js